// The audience of Open Positions. The /positions route guard and the links
// that lead to it both read this, so a link is never offered to an account the
// guard would turn away. ProtectedRoutes lets admin through every guard.
export const POSITIONS_ROLES = ['student', 'admin'];

export function canOpenPositions(roles = []) {
    return roles.some((role) => POSITIONS_ROLES.includes(role));
}

// Where a student "apply" link leads: Open Positions when its route is
// mounted (both flags on) and admits the account, else the fallback.
export function applyEntryHref({
    hiring,
    studentApplication,
    roles,
    fallback,
}) {
    return hiring && studentApplication && canOpenPositions(roles)
        ? '/positions'
        : fallback;
}
